/**
 * Function to search in object by path
 *
 * @attr [objectIn] - Object, to search in, if object is not provided, defaultValue will be returned
 * @attr [path] - Array, path to search in Object
 * @attr [defaultValue] - Any, what to return in case path is not found
 *
 * Example
 * obj = {
 *  a: [
 *      { b : 1 },
 *      { c : 2 }
 *     ],
 *  d:{ e : 3 }
 * };
 * findInObjectByPath(obj, ['a', 0, 'b']) => will return obj.a[0].b
 * findInObjectByPath(obj, ['d', 'e']) => will return obj.d.e
 * findInObjectByPath(obj, ['d', 'f']) => will search for obj.d.f, will return defaultValue because path is not found
 */
import { isPlainObject } from '@elab/core/utils/objectUtils';

export const findInObjectByPath = (objectIn, path, defaultValue = null) => {
    if (!isPlainObject(objectIn)) return defaultValue;
    let obj = objectIn;
    for (let i = 0; i <= path.length - 1; i++) {
        const item = path[i];
        if (!obj[item]) return defaultValue;
        obj = obj[item];
    }

    return obj;
};
